import * as React from 'react'

import { auto } from '@cloudinary/url-gen/actions/resize'
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity'
import { useRecoilValue } from 'recoil'

import fillUrlWithValues from '../../../misc/helpers/fillUrlWithValues'
import routes from '../../../router/routes'
import { cld } from '../../../services/CloudinaryService'
import { translate } from '../../../state/locale/selectors/translate'
import { Link } from '../../reusable/Link'
import styles from './Press.module.scss'
import { IPressProps } from './Press.types'

export const Press = ({ data }: IPressProps) => {
  const i18n = useRecoilValue(translate).press

  return (
    <>
      <h2 className={styles.pageTitle}>{i18n.title}</h2>
      {/*<p className={styles.paragraph}>{lang.description}</p>*/}
      <div className={styles.pressWrapper}>
        {data.map((item) => {
          const imageUrl = cld
            .image(item.image.provider_metadata.public_id)
            .format('auto')
            .quality('auto')
            .resize(auto().gravity(autoGravity()).width(400).height(400))
            .toURL()

          return (
            <Link
              className={styles.column}
              to={fillUrlWithValues(routes.pressSingle, ':category', item.slug)}
              key={item.id}
            >
              <div className={styles.columnHeader}>
                <img className={styles.cover} src={imageUrl} alt={item.image.alternativeText ?? ''} />
              </div>
              <div className={styles.columnBody}>
                <h3 className={styles.columnTitle}>{item.title}</h3>
                <p className={styles.paragraph}>{item.description}</p>
              </div>
            </Link>
          )
        })}
      </div>
    </>
  )
}
